import { createFileRoute } from '@tanstack/react-router';
import { AuthCard, AuthShell } from '@/features/auth/layout/auth-layout';
import { VerifyEmailPanel } from '@/features/auth/components/verify-email-panel';
import { sanitizeToken } from '@/features/auth/validators/token-search';

export const Route = createFileRoute('/verify-email')({
  validateSearch: (search: Record<string, unknown>): { token?: string } => ({
    token: typeof search.token === 'string' ? search.token : undefined,
  }),
  component: VerifyEmailPage,
});

function VerifyEmailPage() {
  const { token } = Route.useSearch();

  return (
    <AuthShell brandPane>
      <AuthCard>
        <VerifyEmailPanel token={sanitizeToken(token)} />
      </AuthCard>
    </AuthShell>
  );
}
